export default "__VITE_ASSET__4bd7c863__"